module.exports = __webpack_public_path__ + "static/img/storageTop.a4b4b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageTop.png
// module id = Zsd6
// module chunks = 2